var _a;
import { TokenType } from './token';
var Lexer = /** @class */ (function () {
    function Lexer(input) {
        // lexer state
        this.tokens = [];
        this.cOffset = 0;
        this.cLine = 1;
        this.cChar = 1;
        this.input = input.trim().replaceAll('\r', ''); // fuck windows
    }
    Lexer.prototype.tokenize = function () {
        while (this.cOffset < this.input.length) {
            if (this.tokenizeStatic()) {
                continue;
            }
            if (this.tokenizeComment()) {
                continue;
            }
            var ch = this.input.charAt(this.cOffset);
            if (this.isTokenWhitespace(ch)) {
                this.tokenizeWhitespace();
            }
            else if (isNumeric(ch) ||
                (ch == '-' && isNumeric(this.input.charAt(this.cOffset + 1)))) {
                this.tokenizeLiteralInt();
            }
            else if (ch == '"') {
                this.tokenizeLiteralString();
            }
            else if (isLegalIdent(ch)) {
                this.tokenizeIdentifier();
            }
            else {
                throw new Error("unrecognized character '".concat(ch, "' at line ").concat(this.cLine, ", char ").concat(this.cChar));
            }
        }
        return this.tokens // un-map escaped newlines
            .map(function (token) {
            var type = token.type, value = token.value, location = token.location;
            return value === '\\\n' ? { type: type, location: location, value: '' } : token;
        });
    };
    Lexer.prototype.tokenizeStatic = function () {
        for (var _i = 0, _a = Object.entries(Lexer.STATICS); _i < _a.length; _i++) {
            var _b = _a[_i], value = _b[0], type = _b[1];
            if (this.input.startsWith(value, this.cOffset)) {
                this.pushToken(type, value);
                this.cChar += value.length;
                this.cOffset += value.length;
                // Checking for \n here captures both escaped and unescaped newlines
                // allowing us to properly track position within newline-escaped macros
                if (value.endsWith('\n')) {
                    this.cLine += 1;
                    this.cChar = 1;
                }
                return true;
            }
        }
        return false;
    };
    Lexer.prototype.tokenizeComment = function () {
        return this.tokenizeLineComment() || this.tokenizeBlockComment();
    };
    Lexer.prototype.tokenizeLineComment = function () {
        if (!this.input.startsWith('//', this.cOffset)) {
            return false;
        }
        var lineEnd = this.input.indexOf('\n', this.cOffset);
        var text = lineEnd > -1
            ? this.input.substring(this.cOffset, lineEnd)
            : this.input.substring(this.cOffset);
        this.pushToken(TokenType.COMMENT, text);
        this.cChar += text.length;
        this.cOffset += text.length;
        return true;
    };
    Lexer.prototype.tokenizeBlockComment = function () {
        if (!this.input.startsWith('/*', this.cOffset)) {
            return false;
        }
        var line = this.cLine;
        var char = this.cChar;
        for (var i = this.cOffset + 2; i < this.input.length; ++i) {
            if (this.input.startsWith('*/', i)) {
                this.cChar += 2;
                var value = this.input.substring(this.cOffset, i + 2);
                this.tokens.push({
                    type: TokenType.COMMENT,
                    value: value,
                    location: { line: line, char: char },
                });
                this.cOffset += value.length;
                return true;
            }
            else if (this.input.charAt(i) == '\n') {
                ++this.cLine;
                this.cChar = 1;
            }
            else {
                ++this.cChar;
            }
        }
        throw new Error("unterminated block comment at line ".concat(line, ", char ").concat(char));
    };
    Lexer.prototype.tokenizeWhitespace = function () {
        for (var i = this.cOffset; i < this.input.length; ++i) {
            if (!this.isTokenWhitespace(this.input.charAt(i))) {
                var ws = this.input.substring(this.cOffset, i);
                this.pushToken(TokenType.WHITESPACE, ws);
                this.cChar += i - this.cOffset;
                this.cOffset += i - this.cOffset;
                return;
            }
        }
        var ws = this.input.substring(this.cOffset);
        this.pushToken(TokenType.WHITESPACE, ws);
        this.cChar += ws.length;
        this.cOffset = this.input.length;
    };
    Lexer.prototype.tokenizeLiteralInt = function () {
        var start = this.input.charAt(this.cOffset) == '-'
            ? this.cOffset + 1
            : this.cOffset;
        for (var i = start; i < this.input.length; ++i) {
            if (this.input.charAt(i) == '_') {
                continue;
            }
            if (!isNumeric(this.input.charAt(i))) {
                var value_1 = this.input.substring(this.cOffset, i);
                this.pushToken(TokenType.LITERAL_INT, value_1);
                this.cChar += value_1.length;
                this.cOffset += value_1.length;
                return;
            }
        }
        var value = this.input.substring(this.cOffset);
        this.pushToken(TokenType.LITERAL_INT, value);
        this.cChar += value.length;
        this.cOffset = this.input.length;
    };
    Lexer.prototype.tokenizeLiteralString = function () {
        for (var i = this.cOffset + 1; i < this.input.length; ++i) {
            if (this.input.charAt(i) == '"') {
                var literal = this.input.substring(this.cOffset + 1, i); // for quotes, which the captured literal omits
                this.pushToken(TokenType.LITERAL_STRING, literal);
                this.cChar += literal.length + 2;
                this.cOffset += literal.length + 2;
                return;
            }
        }
        throw new Error('unterminated string literal');
    };
    Lexer.prototype.tokenizeIdentifier = function () {
        for (var i = this.cOffset; i < this.input.length; ++i) {
            if (!isLegalIdent(this.input.charAt(i))) {
                var ident = this.input.substring(this.cOffset, i);
                this.pushToken(TokenType.IDENTIFIER, ident);
                this.cChar += ident.length;
                this.cOffset += ident.length;
                return;
            }
        }
        var value = this.input.substring(this.cOffset);
        this.pushToken(TokenType.IDENTIFIER, value);
        this.cChar += value.length;
        this.cOffset = this.input.length;
    };
    Lexer.prototype.pushToken = function (type, value) {
        this.tokens.push({
            type: type,
            value: value,
            location: { line: this.cLine, char: this.cChar },
        });
    };
    Lexer.prototype.isTokenWhitespace = function (c) {
        // newlines are tokenized separately
        return c == ' ' || c == '\t';
    };
    Lexer.STATICS = (_a = {
            '\\\n': TokenType.WHITESPACE,
            '#define': TokenType.PREPROC_DEFINE
        },
        _a['apply'] = TokenType.APPLY,
        _a['false'] = TokenType.FALSE,
        _a['true'] = TokenType.TRUE,
        _a['meta'] = TokenType.META,
        _a['rule'] = TokenType.RULE,
        _a['if'] = TokenType.IF,
        _a['&&'] = TokenType.OP_AND,
        _a['||'] = TokenType.OP_OR,
        _a['>='] = TokenType.OP_GTEQ,
        _a['<='] = TokenType.OP_LTEQ,
        _a['=='] = TokenType.OP_EQ,
        _a['!'] = TokenType.OP_NOT,
        _a['>'] = TokenType.OP_GT,
        _a['<'] = TokenType.OP_LT,
        _a[';'] = TokenType.STMT_END,
        _a[':'] = TokenType.COLON,
        _a['='] = TokenType.ASSIGN,
        _a[','] = TokenType.COMMA,
        _a['('] = TokenType.EXPR_START,
        _a[')'] = TokenType.EXPR_END,
        _a['{'] = TokenType.BLOCK_START,
        _a['}'] = TokenType.BLOCK_END,
        _a['['] = TokenType.LIST_START,
        _a[']'] = TokenType.LIST_END,
        _a['\n'] = TokenType.NEWLINE,
        _a);
    return Lexer;
}());
export { Lexer };
export function isWhitespace(c) {
    return c == ' ' || c == '\t' || c == '\n' || c == '\r';
}
export function isAlpha(c) {
    return (c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z');
}
export function isNumeric(c) {
    return c >= '0' && c <= '9';
}
export function isLegalIdent(c) {
    return c == '_' || isAlpha(c) || isNumeric(c);
}
